import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var ModalHelper = /*#__PURE__*/function () {
  function ModalHelper() {
    var _this = this;

    _classCallCheck(this, ModalHelper);

    this.modals = null;
    this.router = null;

    this.closeAllOpenedModals = function () {
      Object.keys(_this.modals).forEach(function (modalName) {
        var modal = _this.modals[modalName];

        if (modal.opened) {
          _this.closeModal(modal);
        }
      });
    };
  }

  _createClass(ModalHelper, [{
    key: "setHelperParams",
    value: function setHelperParams(modals, unmountComponentCallback) {
      this.modals = modals;
      this.unmountComponentCallback = unmountComponentCallback;
    }
  }, {
    key: "createModalObject",
    value: function createModalObject(modalConfig) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var renderComponent = arguments.length > 2 ? arguments[2] : undefined;
      return Object.assign({
        color: 'primary',
        opened: false,
        options: {
          cssClass: modalConfig.route ? modalConfig.route + '-modal' : ''
        },
        component: function component(params) {
          var selector = document.querySelector('#layout-modal-component').querySelector('.modal-inner-content');
          return renderComponent(selector, params);
        }
      }, options);
    }
  }, {
    key: "getSearchParam",
    value: function getSearchParam(param) {
      var searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(param);
    }
  }, {
    key: "setSearchParam",
    value: function setSearchParam(name, value, url) {
      var onlySearch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var searchParams = new URLSearchParams(url || window.location.search);
      searchParams.set(name, value);
      var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();

      if (onlySearch) {
        return '?' + searchParams.toString();
      }

      return newRelativePathQuery;
    }
  }, {
    key: "closeModal",
    value: function closeModal(modal) {
      if (document.querySelector('#layout-modal-component') && document.querySelector('#layout-modal-component').querySelector('.modal-inner-content')) {
        modal.opened = true;
        var event = new CustomEvent('toggleModal', {
          detail: {
            modal: modal
          }
        });

        if (document.querySelector('#layout-modal-component')) {
          document.querySelector('#layout-modal-component').dispatchEvent(event);
        }

        this.unmountComponentCallback(document.querySelector('#layout-modal-component').querySelector('.modal-inner-content'));
      }
    }
  }, {
    key: "openModal",
    value: function openModal(modal) {
      if (document.querySelector('#layout-modal-component') && document.querySelector('#layout-modal-component').querySelector('.modal-inner-content')) {
        modal.opened = false;
        var event = new CustomEvent('openModal', {
          detail: {
            modal: modal
          }
        });

        if (document.querySelector('#layout-modal-component')) {
          document.querySelector('#layout-modal-component').dispatchEvent(event);
        }
      }
    }
  }, {
    key: "toggleModal",
    value: function toggleModal(modal, routeParams) {
      var _this2 = this;

      var forceUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      Object.keys(this.modals).forEach(function (modalName) {
        var currentModal = _this2.modals[modalName];

        if (modal.route !== currentModal.route) {
          currentModal.opened = false;
        }
      });

      if (modal.opened === true || forceUnmount === true) {
        this.unmountComponentCallback(document.querySelector('#layout-modal-component').querySelector('.modal-inner-content'));
      }

      var event = new CustomEvent('toggleModal', {
        detail: {
          modal: modal,
          params: routeParams
        }
      });

      if (document.querySelector('#layout-modal-component')) {
        document.querySelector('#layout-modal-component').dispatchEvent(event);
      }
    }
  }]);

  return ModalHelper;
}();

export default new ModalHelper();